import { useEffect, useState } from "react";
import ErrorLogout from "../../../helpers/ErrorLogout";
import { Button, Dropdown, Input, message, Modal, Table, Tooltip } from "antd";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { closeBid, getBiddedData, reBid, saveSoldDetails, sellBid } from "../../../api/CommonRequest";
import { PiWarningCircleLight } from "react-icons/pi";
import BidScheduleModal from "./BidScheduleModal";
import WinnerListModal from "./WinnerListModal";
import BidSoldModal from "./BidSoldModal";
const { TextArea } = Input;

function ViewBids({ buyerID }) {


    const navigate = useNavigate();
    const location = useLocation();
    const bidID = location?.state?.bidID || {};
    // console.log(bidID, 'bidID');

    const [myBids, setMyBids] = useState([]);
    const [loader, setLoader] = useState([]);
    const [loader1, setLoader1] = useState(false);
    const [soldLoader, setSoldLoader] = useState(false);
    const [trigger, setTrigger] = useState(false);
    const [approveModal, setApproveModal] = useState(false);
    const [winnerModal, setWinnerModal] = useState(false);
    const [soldModal, setSoldModal] = useState(false);
    const [activeTab, setActiveTab] = useState("active")
    console.log(myBids, "myBids");
    console.log(buyerID, "buyerID");
    console.log(myBids.bidID?.activeBidder, "bidID?.activeBidder");
    const tabs = [
        { label: "Active", value: "active" },
        { label: "Old", value: "ol" },

    ];
    useEffect(() => {
        const bidsCall = async () => {
            try {
                setLoader(true);
                const { data } = await getBiddedData(bidID, { activeTab });
                console.log(data, 'data');

                if (data?.success) {
                    setMyBids(data?.BiddedList);
                    setLoader(false);
                }
            } catch (error) {
                setLoader(false);
                console.log(error);
                console.log(error.message);
                if (error?.response?.status === 401) {
                    ErrorLogout(error);
                }
            }
        };
        bidsCall();
    }, [trigger, bidID, buyerID, activeTab]);
    const handleDetailedView = (bid) => {
        // console.log(bid);
        navigate("/bid-detailed-view", { state: bid });
    };
    const handleBuyerView = (id) => {

        navigate("/buyer-single-view", { state: id })
    };
    const onFinishApproval = async (val) => {
        console.log(val.type, "Values");

        const values = {
            bidStart: val?.startDate ? val?.startDate : '',
            bidEnd: val?.endDate ? val?.endDate : '',
            type: val?.type ? "group" : "public",
            groupID: val?.groupID ? val?.groupID : '',
            initialPrice: val.initialPrice,
            securityAmount: val.securityAmount,
            minBidAmount: val.minBidAmount
        };


        console.log(values, "Values");

        try {
            setLoader1(true);
            const { data } = await reBid(myBids[0]?._id, values);
            console.log(data, 'data');

            if (data?.success) {

                setLoader1(false);
                message.success(data?.message)
                navigate('/bid-list')
            }
        } catch (error) {
            setLoader1(false);
            console.log(error);
            console.log(error.message);
            if (error?.response?.status === 401) {
                ErrorLogout(error);
            }
        }

    }
    const handleSellBid = () => {
        setWinnerModal(true)
    }

    const handleSubmit = async (buyerData) => {
        try {
            setLoader1(true);
            const { data } = await sellBid(myBids[0]?._id, buyerData);
            console.log(data, 'data');

            if (data?.success) {

                setLoader1(false);
                setWinnerModal(false)
                message.success(data?.message)
                navigate('/bid-list')
            }
        } catch (error) {
            setLoader1(false);
            console.log(error);
            console.log(error.message);
            if (error?.response?.status === 401) {
                ErrorLogout(error);
            }
        }
    }
    const handleReBid = () => {
        setApproveModal(true)
    }
    const handleCloseBid = async (rejectNote) => {
        try {
            setLoader1(true);
            console.log(rejectNote, 'rejectNote');

            const { data } = await closeBid(myBids[0]?._id, rejectNote);
            console.log(data, 'data');

            if (data?.success) {

                setLoader1(false);
                message.success(data?.message)
                navigate('/bid-list')
            }
        } catch (error) {
            setLoader1(false);
            console.log(error);
            console.log(error.message);
            if (error?.response?.status === 401) {
                ErrorLogout(error);
            }
        }
    }
    const handleCancel = () => {
        setApproveModal(false)
    };
    const handleCancel1 = () => {
        setWinnerModal(false)
    };

    const confirmBidAction = (action) => {
        let rejectNote = ""; // Variable to store the rejection note
        Modal.confirm({
            title: "Confirm Bid Action",
            // content: `Are you sure you want to ${action} this Bid?`,
            content: (
                <div>
                    <p>
                        Are you sure you want to {action} this Bid?
                    </p>
                    {action === "close" && (
                        <>
                            <p className="mt-3 mb-2 font-semibold">Feedback note</p>
                            <TextArea
                                placeholder="Please provide a reason for colsing"
                                rows={4}
                                style={{ width: "100%" }}
                                onChange={(e) => {
                                    rejectNote = e.target.value;
                                }}
                            />
                        </>
                    )}
                </div>
            ),
            okText: "Yes",
            cancelText: "No",
            onOk: () => {
                if (action === "close" && !rejectNote.trim()) {
                    Modal.error({
                        title: "Feedback Note Required",
                        content: "Please provide a reason for closing the bid.",
                    });
                    // return Promise.reject(); // Prevent the modal from closing
                    // return Promise.reject("Feedback note is required");
                    return
                }
                // return action === 'sell' ? handleSellBid() : action === 're-bid' ? handleReBid() : handleCloseBid(rejectNote);
                // if (action === 'sell') {
                //     handleSellBid()
                // }else if (action === 're-bid') {
                //     handleReBid()
                // }else if (action === 'close'  && rejectNote) {
                //     handleCloseBid(rejectNote)
                // }
                try {
                    if (action === "sell") {
                        handleSellBid();
                    } else if (action === "re-bid") {
                        handleReBid();
                    } else if (action === "close") {
                        handleCloseBid(rejectNote.trim());
                    } else if (action === "sold") {
                        handleMakeSold();
                    }
                } catch (error) {
                    console.error("Error handling bid action:", error);
                    Modal.error({
                        title: "Action Failed",
                        content: `An error occurred while processing the ${action} action.`,
                    });
                }
            },
            onCancel() {
                console.log("Action cancelled");
            },
        });
    };

    const handleMakeSold = () => {
        setSoldModal(true)
    }

    const handleSoldCancel = () => {
        setSoldModal(false)
    };

    const onFinishSold = async (val) => {
        console.log(val, "Values");

        // const values = {
        //     bidStart: val?.startDate ? val?.startDate : '',
        //     bidEnd: val?.endDate ? val?.endDate : '',
        //     type: val?.type ? "group" : "public",
        //     groupID: val?.groupID ? val?.groupID : '',
        //     initialPrice: val.initialPrice,
        //     securityAmount: val.securityAmount,
        //     minBidAmount: val.minBidAmount
        // };


        // console.log(values, "Values");

        try {
            setSoldLoader(true);
            const { data } = await saveSoldDetails(myBids[0]?._id, val);
            console.log(data, 'data');

            if (data?.success) {

                setSoldLoader(false);
                setSoldModal(false)
                message.success(data?.message)
                navigate('/bid-list')
            }
        } catch (error) {
            setSoldLoader(false);

            console.log(error);
            console.log(error.message);
            if (error?.response?.status === 401) {
                ErrorLogout(error);
            }
        }

    }

    const items1 = [
        {
            key: '1',
            label: (<div onClick={() => { confirmBidAction("sell") }}>Sell</div>)
        },
        {
            key: '2',
            label: (<div onClick={() => { confirmBidAction("re-bid") }}>Re Bid</div>)

        },
        {
            key: '3',
            label: (<div onClick={() => { confirmBidAction("close") }}>Close Bid</div>)

        },
    ];
    const items2 = [

        {
            key: '1',
            label: (<div onClick={() => { confirmBidAction("re-bid") }}>Re Bid</div>)

        },
        {
            key: '2',
            label: (<div onClick={() => { confirmBidAction("close") }}>Close Bid</div>)

        },
    ];
    // console.log(myBids[0]?.bids?.length,'myBids?.bids?.length');

    const items = myBids[0]?.bids?.length === 0 ? items2 : items1

    const column = [
        {
            title: (
                <span className="text-[#4A4A4C] text-[14px] font-mediums">Sl.No</span>
            ),
            dataIndex: "_id",
            render: (text, record, index) => (
                <span className="text-[#878787] text-[16px] font-medium">
                    {index + 1}
                </span>
            ),
            align: "center",
        },

        {
            title: (
                <span className="text-[#4A4A4C] text-[14px] font-mediums">Name</span>
            ),
            dataIndex: "bidID",
            render: (bidID) => (
                <span className="text-[#313131] font-semibold text-[16px]">
                    {bidID?.productName}
                </span>
            ),

            sorter: (a, b) => a.name.localeCompare(b.name),
            align: "center",
        },

        {
            title: (
                <span className="text-[#4A4A4C] text-[14px] font-medium">
                    Current Bid
                </span>
            ),
            dataIndex: "bidID",
            render: (bidID) => (
                <span className="text-[#878787] text-[16px] font-medium">
                    {bidID?.bidLivePrice}
                </span>
            ),

            align: "center",
        },

        {
            title: (
                <span className="text-[#4A4A4C] text-[14px] font-mediums">
                    Bid Count
                </span>
            ),
            dataIndex: "bids",
            render: (bids) => (
                <span className="text-[#878787] text-[16px] font-medium">
                    {bids.length}
                </span>
            ),

            align: "center",
        },
        // Table.EXPAND_COLUMN,
        {
            title: (
                <span className="text-[#4A4A4C] text-[14px] font-mediums">Status</span>
            ),
            dataIndex: "bidID",
            render: (bidID) => {
                const status =
                    moment(bidID?.bidEnd) > Date.now()
                        ? "Live"
                        : bidID?.activeBidder === buyerID
                            ? "Won"
                            : "Expired";
                const statusClass =
                    status === "Live"
                        ? "text-[#01A208] text-[16px] font-medium"
                        : status === "Won"
                            ? "text-[#F08200] text-[16px] font-medium"
                            : "text-[#878787] text-[16px] font-medium";
                return <span className={statusClass}>{status}</span>;
            },
            align: "center",
        },

        {
            title: (
                <span className="text-[#4A4A4C] text-[14px] font-mediums">
                    Last Bid
                </span>
            ),
            dataIndex: "bids",
            render: (bids) => (
                <span className="text-[#878787] text-[16px] font-medium">
                    {bids.length === 0 ? 'NA' : moment(bids[bids.length - 1]?.createDate).format("DD MMM YYYY HH:mm")}
                </span>
            ),
            align: "center",
        },

        {
            title: (
                <span className="text-[#4A4A4C] text-[14px] font-mediums">Actions</span>
            ),
            dataIndex: "bidID",
            align: "center",
            render: (bidID) => (
                <>
                    <div className="gap-2 flex justify-center items-center">
                        <Button
                            className=" h-10 cursor-pointer bg-[#1955EB] font-semibold text-[16px] px-3 text-white rounded-md  py-2 mr-2"
                            onClick={() => handleDetailedView(bidID._id)}
                        >
                            View Product
                        </Button>
                        {activeTab === "active" && (moment(bidID?.bidEnd) < Date.now() && bidID?.status === 'live') &&
                            <Dropdown
                                menu={{
                                    items,
                                }}
                                placement="bottom"
                                arrow
                            >
                                <Button className="h-10 cursor-pointer bg-[#1955EB] font-semibold text-[16px] px-6 text-white rounded-md  py-2 mr-2">Action </Button>
                            </Dropdown>
                        }
                        {bidID?.status === 'sell' &&
                            <Button
                                className=" h-10 cursor-pointer bg-[#1955EB] font-semibold text-[16px] px-3 text-white rounded-md  py-2 mr-2"
                                onClick={() => { confirmBidAction("sold") }}
                            >
                                Product Sold
                            </Button>
                        }
                    </div>
                </>
            ),
        },
    ];

    const columns = [
        {
            title: "Rank",
            dataIndex: "index",
            key: "index",
            render: (text, record, rowIndex) => rowIndex + 1,
        },
        {
            title: "Count",
            dataIndex: "bidCount",
            key: "bidCount",
        },
        {
            title: "Buyer",
            dataIndex: "userID",
            key: "userID",
            render: (text) => <a>{text?.name}</a>,
        },

        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
        },
        {
            title: "Created At",
            dataIndex: "createDate",
            key: "createDate",
            render: (text) => <a >{moment(text).format("DD/MM/YYYY HH:MM")}</a>,
        },
        {
            title: "Profile ",
            dataIndex: "userID",
            key: "userID",
            render: (text) => <Button onClick={() => handleBuyerView(text._id)}>View</Button>,
        },
    ];




    return (
        <div className="container">
            <div className="flex border border-[#9FACF0] p-1.5 gap-1.5 rounded-[12px] w-max bg-white m-6">
                {tabs.map((tab) => (
                    <button
                        key={tab.value}
                        className={`h-10 px-6 whitespace-nowrap rounded-lg text-sm transition-all duration-200
                  ${activeTab === tab.value
                                ? "bg-white text-[#1955EB] font-semibold shadow-sm border border-blue-100"
                                : "bg-transparent text-gray-500 hover:bg-gray-50 font-medium"
                            }`}
                        onClick={() => {
                            setActiveTab(tab.value);

                        }}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div className="shadow-lg hover:shadow-xl rounded-xl mt-4 overflow-x-auto">
                <Table
                    className="min-w-full divide-y divide-gray-200"
                    columns={column}
                    pagination={false}
                    loading={loader}
                    dataSource={myBids}
                    rowKey={(record) => record._id}
                    expandable={{
                        expandedRowRender: (record) => (
                            <Table className=" divide-y divide-gray-200" columns={columns} dataSource={[...record.bids].reverse()}
                                pagination={{
                                    total: record.bids?.length,
                                    showTotal: (total, range) =>
                                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                                    showSizeChanger: true,
                                    // onShowSizeChange: onShowSizeChange,
                                    // itemRender: itemRender,
                                }}
                            />
                        ),
                        expandIcon: () => null,
                    }}
                    expandedRowKeys={myBids.map((bid) => bid._id)}
                />
                {myBids.length === 0 && <Dropdown
                    menu={{
                        items,
                    }}
                    placement="bottom"
                    arrow
                >
                    <Button className="h-10 my-10 cursor-pointer bg-[#1955EB] font-semibold text-[16px] px-6 text-white rounded-md  py-2 mr-2">Action </Button>
                </Dropdown>}
            </div>
            <BidScheduleModal approveModal={approveModal} handleCancel={handleCancel} onFinishApproval={onFinishApproval} status={'live'} />
            <WinnerListModal winnerModal={winnerModal} handleCancel={handleCancel1} winnerList={myBids[0]?.bids} loader={loader1} handleSubmit={handleSubmit} />
            <BidSoldModal soldModal={soldModal} handleCancel={handleSoldCancel} onFinish={onFinishSold} currentPrice={myBids[0]?.bidID?.bidLivePrice} loader={soldLoader} />

        </div>
    );
}

export default ViewBids;
